import styled from 'styled-components';

const CardRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0 2rem;
`;

export default CardRow;
